import Vue from "vue"
import {mapState,mapMutations} from "vuex";

export default {
   props: {
      filter_text: {
         default() { return ''; }
      }
   },
   methods: {
      ...mapMutations([
         'SET_FILTERED_ITEM_COUNT',
         'SET_DISPLAY_ITEM_COUNT',
         'INCREMENT_CAPABILITY_COUNT',
         'RESET_CAPABILITIES_COUNT',
         'SET_MODAL_VISIBILITY'
      ]),
      dataset_datetime_value: function(datetime) {
         const datetime_value_array = datetime.split("T");
         return datetime_value_array[0];
      },
      dataset_start_stop_time: function(start_stop_datetime) {
         let start_stop_time = '';
         if(start_stop_datetime[0]['RangeDateTimes'] != undefined) {
            const starttime = this.dataset_datetime_value(start_stop_datetime[0]['RangeDateTimes'][0]["BeginningDateTime"]);
            let stoptime = '';
            if(start_stop_datetime[0]['RangeDateTimes'][0]["EndingDateTime"] != undefined) stoptime = this.dataset_datetime_value(start_stop_datetime[0]['RangeDateTimes'][0]["EndingDateTime"]);

            if(starttime) start_stop_time += starttime;
            if(starttime && !stoptime) stoptime = 'Present';
            if(stoptime) start_stop_time += ' to ' + stoptime;
         } else if(start_stop_datetime[0]['SingleDateTimes'] != undefined)
            start_stop_time = this.dataset_datetime_value(start_stop_datetime[0]['SingleDateTimes'][0]);
         return start_stop_time;
      },
      dataset_url: function(dataset, hash='') {
         let url = '';
         let return_path = 'dataset/' + dataset['umm']['ShortName'];
         let base_path = "/";
         if(hash) return_path += '#' + hash;
         //console.log(this.drupal_cloud_datasets_data);
         //if(this.drupal_cloud_datasets_data && this.drupal_cloud_datasets_data.base_path) base_path = this.drupal_cloud_datasets_data.base_path;
         if(this.basePath) base_path = this.basePath;
         url = base_path + return_path;
         return url;
      },
      dataset_unique_science_keywords: function(science_keywords) {
         let keywords = new Set();
         Vue._.forEach(science_keywords, function(science_keyword) {
            Vue._.forOwn(science_keyword, function(value, key) {
               //if(key.toLowerCase() != 'category' && key.toLowerCase() != 'detailedvariable') keywords.add(value);
               if(key.indexOf('VariableLevel1') >= 0) keywords.add(value);
            });
         });

         return Array.from(keywords);
      },
      loadMore: function() {
         this.SET_DISPLAY_ITEM_COUNT(this.load_item_count);
      },
      dataset_coverage_bound: function(coverage, return_type='label') {
         let bounding_data_return = [];
         //console.log(coverage);
         if(coverage["horizontalspatialdomain"] != undefined && coverage["horizontalspatialdomain"]["geometry"] != undefined && coverage["horizontalspatialdomain"]["geometry"]["boundingrectangles"] != undefined) {
            //const bounding_rectangle = coverage["horizontalspatialdomain"]["geometry"]["boundingrectangles"][0];
            const bounding_rectangles = coverage["horizontalspatialdomain"]["geometry"]["boundingrectangles"];

            // if(return_type == 'map') {
            //    bounding_data_return = [[],[]];
            //    if(bounding_rectangle != undefined) {
            //       bounding_data_return[0] = [bounding_rectangle["northboundingcoordinate"],bounding_rectangle["westboundingcoordinate"]];
            //       bounding_data_return[1] = [bounding_rectangle["southboundingcoordinate"],bounding_rectangle["eastboundingcoordinate"]];
            //    }
            // } else {
            Vue._.forEach(bounding_rectangles, function(bounding_rectangle) {
               bounding_data_return.push({
                  'N':bounding_rectangle["northboundingcoordinate"],
                  'S':bounding_rectangle["southboundingcoordinate"],
                  'W':bounding_rectangle["westboundingcoordinate"],
                  'E':bounding_rectangle["eastboundingcoordinate"]
               });
            });
               // bounding_data_return.push({
               //    'N':bounding_rectangle["northboundingcoordinate"],
               //    'S':bounding_rectangle["southboundingcoordinate"],
               //    'W':bounding_rectangle["westboundingcoordinate"],
               //    'E':bounding_rectangle["eastboundingcoordinate"]
               // });
               
               /*
               bounding_data_return += "<span class='faceted-browse-subLabel'>N: </span> " + bounding_rectangle["northboundingcoordinate"] + ", ";
               bounding_data_return += "<span class='faceted-browse-subLabel'>S: </span> " + bounding_rectangle["southboundingcoordinate"] + ", ";
               bounding_data_return += "<span class='faceted-browse-subLabel'>W: " + bounding_rectangle["westboundingcoordinate"] + ", ";
               bounding_data_return += "<span class='faceted-browse-subLabel'>E: </span> " + bounding_rectangle["eastboundingcoordinate"];
               */
            //}
         } 
         // else {
         //    bounding_data_return.push({
         //       'N':"",
         //       'S':"",
         //       'W':"",
         //       'E':""
         //    });
         // }

         return bounding_data_return;
      },
      dataset_coverage_bboxes: function(coverage) {
         let bboxes = [];
         let bounding_data_return = [[],[]];
         if(coverage["horizontalspatialdomain"] != undefined && coverage["horizontalspatialdomain"]["geometry"] != undefined) {
            if(coverage["horizontalspatialdomain"]["geometry"]["boundingrectangles"] != undefined) {
               let bounding_rectangles = coverage["horizontalspatialdomain"]["geometry"]["boundingrectangles"];
               if(bounding_rectangles != undefined) {
                  Vue._.forEach(bounding_rectangles, function(bounding_rectangle) {
                     if(bounding_rectangle["eastboundingcoordinate"] < 0 && bounding_rectangle["westboundingcoordinate"] > 0) {
                        bounding_data_return = [[bounding_rectangle['southboundingcoordinate'],180],[bounding_rectangle['northboundingcoordinate'],bounding_rectangle["westboundingcoordinate"]]];
                        bboxes.push(bounding_data_return);
                        bounding_data_return = [[bounding_rectangle['southboundingcoordinate'],bounding_rectangle['eastboundingcoordinate']],[bounding_rectangle['northboundingcoordinate'],-180]];
                        bboxes.push(bounding_data_return);
                     } else if(bounding_rectangle["northboundingcoordinate"] < 0 && bounding_rectangle["southboundingcoordinate"] > 0){
                        bounding_data_return = [[-180,bounding_rectangle['eastboundingcoordinate']],[bounding_rectangle['northboundingcoordinate'],bounding_rectangle["westboundingcoordinate"]]];
                        bboxes.push(bounding_data_return);
                        bounding_data_return = [[bounding_rectangle['southboundingcoordinate'],bounding_rectangle['eastboundingcoordinate']],[180,bounding_rectangle["westboundingcoordinate"]]];
                        bboxes.push(bounding_data_return);
                     } else {
                        bounding_data_return = [[bounding_rectangle["northboundingcoordinate"],bounding_rectangle["westboundingcoordinate"]],[bounding_rectangle["southboundingcoordinate"],bounding_rectangle["eastboundingcoordinate"]]];
                        bboxes.push(bounding_data_return);
                     } 
                  });
               }
            }
         }
         /*
         if(coverage["horizontalspatialdomain"] != undefined && coverage["horizontalspatialdomain"]["geometry"] != undefined && coverage["horizontalspatialdomain"]["geometry"]["boundingrectangles"] != undefined) {
            //const bounding_rectangle = coverage["horizontalspatialdomain"]["geometry"]["boundingrectangles"][0];
            const bounding_rectangles = coverage["horizontalspatialdomain"]["geometry"]["boundingrectangles"];            
            if(bounding_rectangles != undefined) {
               Vue._.forEach(bounding_rectangles, function(bounding_rectangle) {
                  if(bounding_rectangle["eastboundingcoordinate"] < 0 && bounding_rectangle["westboundingcoordinate"] > 0) {
                     bounding_data_return = [[bounding_rectangle['southboundingcoordinate'],180],[bounding_rectangle['northboundingcoordinate'],bounding_rectangle["westboundingcoordinate"]]];
                     bboxes.push(bounding_data_return);
                     bounding_data_return = [[bounding_rectangle['southboundingcoordinate'],bounding_rectangle['eastboundingcoordinate']],[bounding_rectangle['northboundingcoordinate'],-180]];
                     bboxes.push(bounding_data_return);
                  } else if(bounding_rectangle["northboundingcoordinate"] < 0 && bounding_rectangle["southboundingcoordinate"] > 0){
                     bounding_data_return = [[-180,bounding_rectangle['eastboundingcoordinate']],[bounding_rectangle['northboundingcoordinate'],bounding_rectangle["westboundingcoordinate"]]];
                     bboxes.push(bounding_data_return);
                     bounding_data_return = [[bounding_rectangle['southboundingcoordinate'],bounding_rectangle['eastboundingcoordinate']],[180,bounding_rectangle["westboundingcoordinate"]]];
                     bboxes.push(bounding_data_return);
                  } else {
                     bounding_data_return = [[bounding_rectangle["northboundingcoordinate"],bounding_rectangle["westboundingcoordinate"]],[bounding_rectangle["southboundingcoordinate"],bounding_rectangle["eastboundingcoordinate"]]];
                     bboxes.push(bounding_data_return);
                  } 
               });
            } else {
               bboxes.push(bounding_data_return);
            }
         } else {
            bboxes.push(bounding_data_return);
         }
         */
         return bboxes;
      },
      dataset_coverage_bounding_points: function(coverage) {
         let bpoints = [];         
         if(coverage["horizontalspatialdomain"] != undefined && coverage["horizontalspatialdomain"]["geometry"] != undefined) {            
            if(coverage["horizontalspatialdomain"]["geometry"]["points"] != undefined) {
               let bounding_points = coverage["horizontalspatialdomain"]["geometry"]["points"];
               if(bounding_points != undefined) {
                  Vue._.forEach(bounding_points, function(bounding_point) {
                     bpoints.push([bounding_point['longitude'],bounding_point['latitude']]);
                  });
               }
            }
         }
         return bpoints;
      },
      dataset_temporal_output: function(temporal_data, temporal_part) {
         let temporal_value = [], return_value = '', temporal_part_index = 0;
         if(temporal_part == 'end') temporal_part_index = 1;
         temporal_data = this.convertKeysToLowerCase(temporal_data);
         
         //console.log(temporal_data);
         if(temporal_data[0]["singledatetimes"] != undefined) {
            temporal_value.push(temporal_data[0]["singledatetimes"][0].split("T")[0])
         } else {
            temporal_value.push(temporal_data[0]["rangedatetimes"][0]["beginningdatetime"].split("T")[0]);
            if(temporal_data[0]["rangedatetimes"][0]["endingdatetime"] != undefined) {
               switch(temporal_data[0]["rangedatetimes"][0]["endingdatetime"]) {
                  case "-":
                  case "":
                     temporal_value.push("Present");
                  break;
                  default:
                     temporal_value.push(temporal_data[0]["rangedatetimes"][0]["endingdatetime"].split("T")[0]);
               }
            } else {
               temporal_value.push("Present");
            }
         }

         if(typeof temporal_value[temporal_part_index] === 'undefined') {
            //pass
         } else {
            return_value = temporal_value[temporal_part_index];
         }


         //return temporal_value.join(" to ");
         //return temporal_value;
         return return_value;
         /*
         $coverage = '';
         $coverageDateTime = $dataset->umm->TemporalExtents[0]->RangeDateTimes[0];

         $coverage .= mission_template_dataset_format_temporal_date_time($coverageDateTime->BeginningDateTime) . " to ";
         if(!isset($coverageDateTime->EndingDateTime)) $coverageDateTime->EndingDateTime = "";
         switch($coverageDateTime->EndingDateTime)
         {
            case "-":
            case "":
               $coverage .= "Present";
               break;
            default:
               $coverage .= mission_template_dataset_format_temporal_date_time($coverageDateTime->EndingDateTime);
         }
         $dataset->umm->TemporalExtents[0]->Coverage = $coverage;
         */
      },
      datset_granule_time_span: function(granule_time_data) {
         //console.log(granule_time_data);
         let granule_start = '', granule_end = '', return_value = '';
         let self = this;
         granule_time_data.forEach(function(element) {
            //console.log(element);
            if(element['name'] == 'earliest_granule_start_time' && element['value']) granule_start = self.dataset_datetime_value(element['value']);
            if(element['name'] == 'latest_granule_ummg_end_time' && element['value']) {
               granule_end = self.dataset_datetime_value(element['value']);
            } else {
               granule_end = 'Present';
            }
         });
         //console.log(granule_start);
         
         if(granule_start) {
            return_value = granule_start;
            if(granule_end) return_value += " To " + granule_end;
         }
         //console.log(return_value);
         return return_value;
      },
      get_service_text: function(service_id, fieldName="LongName") {
         const service = this.umm_s.items.filter(item => item["meta"]["concept-id"] == service_id);
         let return_value = service_id;
         if(service != undefined) {
            if(fieldName == 'badge') {
               return_value = service[0]["umm"]["Type"];
               if(service[0]["umm"]["LongName"].indexOf("Subsetter") >= 0) return_value = "Subsetter";
            } else {
               return_value = service[0]["umm"][fieldName];
            }
         }
         return return_value;
      },
      get_document_label: function(document) {
         if(document['Description']) {
            return document['Description'];
         } else {
            return document['URL'];
         }
      },
      filter_data_access_urls: function(urls) {
         let filterd_urls = [];
         filterd_urls = urls.filter(function(url) {
            if(url['URLContentType'] == "DistributionURL" && (url["Type"] == "GET DATA")) {
               //url["Label"] = url["Subtype"];
               url["Label"] = url["Description"];
               if(url["Subtype"] == "Earthdata Search") url["Label"] = "Search Granules";
               if(url["Subtype"] == "DATA TREE" && url["Type"] == "GET DATA") url["Label"] = "Browse Granule Listing";
               return true;
            }
         });

         filterd_urls = Vue._.orderBy(filterd_urls, ["Subtype"]);


         return filterd_urls;
      },
      filter_tutorials_related_urls: function(urls) {
         let filtered_urls = [];
         //console.log(urls);
         if(urls) {
            filtered_urls = urls.filter(function(url) {
               if(url["Subtype"] == "DATA RECIPE") return true;
            });
         }
         //console.log(filtered_urls);
         return filtered_urls;
      },
      datasetFieldValue: function(dataset, fieldStructure) {
         //let fieldValue = undefined;
         let umm_data = JSON.parse(JSON.stringify(dataset["umm"]));
         let field = this.convertKeysToLowerCase(umm_data);
         //let field = this.convertKeysToLowerCase(dataset["umm"]);
         let found = false;
         fieldStructure.forEach(function(fieldkey) {
            if(found) found = false;
            Object.keys(field).forEach(key => {
               if(fieldkey.toLowerCase() == key) {
                  field = field[key];
                  found = true;
               }
            });
         });

         if(!found) field = undefined;

         return field;
      },
      convertKeysToLowerCase(obj) {
         const self = this;
         var output = {};
         for (let i in obj) {
            if (Object.prototype.toString.apply(obj[i]) === '[object Object]') {
                output[i.toLowerCase()] = self.convertKeysToLowerCase(obj[i]);
            }else if(Object.prototype.toString.apply(obj[i]) === '[object Array]'){
               output[i.toLowerCase()]=[];
               obj[i].forEach(function(array_element) {
                  if(Object.prototype.toString.apply(array_element) === '[object String]') {
                     output[i.toLowerCase()].push(array_element);
                  } else {
                     output[i.toLowerCase()].push(self.convertKeysToLowerCase(array_element));
                  }
               });
               //output[i.toLowerCase()].push(self.convertKeysToLowerCase(obj[i][0]));
            } else {
               output[i.toLowerCase()] = obj[i];
            }
         }
         return output;
      },
      capabilities_filter_count: function(dataset) {
         const self = this;
         //if(dataset['umm']['ShortName'] == 'MODIS_A-JPL-L2P-v2019.0') console.log(dataset);
         Vue._.forOwn(this.capabilities, function(capability, key) {
            const intersect = self.capability_filter_count(capability, dataset);
            if(intersect.length > 0) self.INCREMENT_CAPABILITY_COUNT(key);
         });
      },
      capability_filter_count: function(capability, dataset) {
         let capability_tools_services = [];
         let dataset_tools_services = [];
         let intersect = [];
         if(Array.isArray(capability.tools_services)) {
            capability.tools_services.forEach(function(item) {
               capability_tools_services.push(item['concept-id']);
            });
            if(dataset['meta']['associations'] && dataset['meta']['associations']['services']) dataset_tools_services = dataset_tools_services.concat(dataset['meta']['associations']['services']);
            if(dataset['meta']['associations'] && dataset['meta']['associations']['tools']) dataset_tools_services = dataset_tools_services.concat(dataset['meta']['associations']['tools']);

            intersect = Vue._.intersection(capability_tools_services, dataset_tools_services);
         }

         return intersect;
      },
      order_datasets: function(datasets) {
         return datasets.filter(item => {

         });
      },
      data_access_tool_sample_preprocessing: function(data_access_samples){
         if((typeof data_access_samples) === 'object') {
            let sample_data = [];
            for(const [key, sample] of Object.entries(data_access_samples)) {
               if(sample) sample_data.push(`<p><strong>${key}</strong>: ${sample}</p>`);
            }
            data_access_samples = "<div>" + sample_data.join('') + "</div>";
         }
         return data_access_samples;
      },      
      capabilities_service_classes: function(key, capability, tools_serviecs) {
         let classes = ['capability-icon'], self = this, found = undefined;
         //console.log(tools_serviecs);
         let tool_serviec_ids = (tools_serviecs['services'] != undefined) ? tools_serviecs['services'] : [];
         //console.log(tool_serviec_ids);
         if(tools_serviecs['tools'] != undefined) tool_serviec_ids = tool_serviec_ids.concat(tools_serviecs['tools']);
         //console.log(tool_serviec_ids);
         tool_serviec_ids.forEach((concept_id) => {
            found = Vue._.find(Vue._.filter(self.umm_s['items'], function(service) {
                           return service['meta']['concept-id'] == concept_id;
                        }), function(service) {
                           return Vue._.find(service['umm']['ServiceKeywords'], function(keywords) {
                              return capability['MappedTerm'].includes(keywords['ServiceTerm']);
                           });
                        });
            if(found != undefined && !classes.includes('tool-service-capability'))  {
               //classes.push('tool-service-capability');
               classes.push('selected');
            }
         });

         classes.push('icon-' + key);

         return classes;
      },
      show_services_tools_modal: function(info, capability, associations) {
         let capability_tools_services = [];
         capability['tools_services'].forEach(tool_service => {
            capability_tools_services.push(tool_service['concept-id']);
         });

         const has_services = Vue._.intersection(capability_tools_services, associations['services']);
         const has_tools = Vue._.intersection(capability_tools_services, associations['tools']);
         
         let tools_services_list = {'services':[],'tools':[]};
         capability['tools_services'].forEach(tool_service => {
            if(has_services.includes(tool_service['concept-id'])) tools_services_list['services'].push(tool_service);
         });
         
         capability['tools_services'].forEach(tool_service => {
            if(has_tools.includes(tool_service['concept-id'])) {
               if(info['dataset']['data_access_samples'] != undefined && info['dataset']['data_access_samples']['tools'][tool_service['concept-id']] != undefined) {
                  tool_service['execution-url'] = info['dataset']['data_access_samples']['tools'][tool_service['concept-id']];
                  //console.log(tool_service['execution-url']);
                  tools_services_list['tools'].push(tool_service);
               } else {
                  //if(tool_service['information-url'].indexOf('data-subscriber') >= 0) {
                     Vue.axios.get('/api/' + info['dataset']['umm']['ShortName'] + '/data-access-samples/' + tool_service['concept-id']).then(function(response) {
                        // if(response.data.subscriber != undefined) {
                        //    tool_service['execution-url'] = response.data.subscriber;
                        // }
                        if(response.data != undefined) {
                           tool_service['execution-url'] = response.data;
                        }                        
                        tools_services_list['tools'].push(tool_service);
                     }).catch(errors => {
                        console.log(errors);
                        tools_services_list['tools'].push(tool_service);
                     });                  
                  //}
                  //tools_services_list['tools'].push(tool_service);
               }
               // if(tool_service['information-url'].indexOf('data-subscriber') >= 0) {
               //    Vue.axios.get('/api/' + info['dataset']['umm']['ShortName'] + '/subscriber').then(function(response) {
               //       if(response.data.subscriber != undefined) {
               //          tool_service['execution-url'] = response.data.subscriber;
               //       }
               //       tools_services_list['tools'].push(tool_service);
               //     }).catch(errors => {
               //       console.log(errors);
               //       tools_services_list['tools'].push(tool_service);
               //     });
               // } else {
               //    tools_services_list['tools'].push(tool_service);
               // }
               //tools_services_list['tools'].push(tool_service);               
            }
         });

         // associations['services'].forEach((concept_id) => {
         //    let service_found = Vue._.find(Vue._.filter(self.umm_s['items'], function(service) {
         //                   return service['meta']['concept-id'] == concept_id;
         //                }), function(service) {
         //                   return Vue._.find(service['umm']['ServiceKeywords'], function(keywords) {
         //                      return capability['MappedTerm'].includes(keywords['ServiceTerm']);
         //                   });
         //                });

         //    if(service_found != undefined) found = service_found;
         // });
         //if(tools_services_list['tools'].length > 0 || tools_services_list['services'].length > 0) {            
            //this.serviceToolsModalVisible = true;
            this.SET_MODAL_VISIBILITY({'modal_name':'tools_services', visibility:true});
            //console.log({'info':info,'tools':capability['tools_services']});
            this.SET_SERVICES_TOOLS({'info':info,'tools_services_list':tools_services_list});
         //}
      }
      //log(debug) {console.log(debug);}
   },
   computed: {
      ...mapState([
         "cloud_datasets",
         "selected_services",
         "modal_science_keyword",
         "capabilities",
         "sort_by"
      ]),
      filtered_datasets: function() {
         let self = this;
         // const iteratees = obj => obj['umm']['EntryTitle'];
         // const sorted_datasets = Vue._.sortBy(self.cloud_datasets, iteratees);

         self.RESET_CAPABILITIES_COUNT();
         let filtered_datasets = self.cloud_datasets.filter(function(dataset) {
            let to_return = true;
            if(to_return && self.$props.filter_text != '') {
               if(dataset['umm']['EntryTitle'].toLowerCase().indexOf(self.$props.filter_text.toLowerCase()) === -1 && dataset['umm']['ShortName'].toLowerCase().indexOf(self.$props.filter_text.toLowerCase()) === -1 && dataset['umm']['Abstract'].toLowerCase().indexOf(self.$props.filter_text.toLowerCase()) === -1) {
                  to_return = false;
               }

               if(!to_return) {
                  Vue._.forEach(dataset['umm']['Projects'], function(project) {
                     if(project['ShortName'].toLowerCase().indexOf(self.$props.filter_text.toLowerCase()) !== -1) {
                        to_return = true;
                        return;
                     }
                  });
               }

               if(!to_return) {
                  Vue._.forEach(dataset['umm']['Platforms'], function(platform) {
                     if(platform['ShortName'] != undefined && platform['LongName'] != undefined && (platform['ShortName'].toLowerCase().indexOf(self.$props.filter_text.toLowerCase()) !== -1 || platform['LongName'].toLowerCase().indexOf(self.$props.filter_text.toLowerCase()) !== -1)) {
                        to_return = true;
                        return;
                     }
                  });
               }
            }

            if(to_return && self.selected_services.length > 0) {
               if(dataset['meta']['associations'] != undefined && (dataset['meta']['associations']['services'] != undefined || dataset['meta']['associations']['tools'])) {

                  //let intersect = dataset['meta']['associations']['services'].filter(service => self.selected_services.includes(service));

                  self.selected_services.forEach(function(selected_service) {
                     let found = undefined;
                     let capability = self.capabilities[selected_service.charAt(0).toUpperCase() + selected_service.slice(1)];
                     let capability_tools_services = [], dataset_tools_services = [], intersect = [];
                     //console.log(capability);
                     if(Array.isArray(capability.tools_services)) {
                        capability.tools_services.forEach(function(item) {
                           capability_tools_services.push(item['concept-id']);
                        });
                        if(dataset['meta']['associations']['services']) dataset_tools_services = dataset_tools_services.concat(dataset['meta']['associations']['services']);
                        if(dataset['meta']['associations']['tools']) dataset_tools_services = dataset_tools_services.concat(dataset['meta']['associations']['tools']);

                        intersect = Vue._.intersection(capability_tools_services, dataset_tools_services);
                        //console.log(intersect);
                        if(intersect.length == 0) to_return = false;
                     }
                     /*
                     let associated_services = Vue._.filter(self.umm_s['items'], function(service_data) {
                        return dataset['meta']['associations']['services'].includes(service_data['meta']['concept-id']);
                     });
                     if(associated_services != undefined) {
                        //console.log(associated_services);
                        associated_services.forEach(function(associated_service) {
                           found = Vue._.find(associated_service['umm']['ServiceKeywords'], function(keywords) {
                              return capability['MappedTerm'].includes(keywords['ServiceTerm']);
                           });

                           if(found == undefined) to_return = false;
                        });
                     }
                     */
                  });

                  //let intersect = dataset['umm']['data_access'].filter(data_access => self.selected_services.includes(data_access));
                  //if(intersect.length == 0) to_return = false;
               } else {
                  to_return = false;
               }
            }

            if(to_return) {
               //self.RESET_CAPABILITIES_COUNT();
               self.capabilities_filter_count(dataset);
               dataset['umm']["tutorials"] = self.filter_tutorials_related_urls(dataset['umm']["RelatedUrls"]);
            }

            return to_return;
         });
         //console.log(this.capabilities);
         //self.filtered_item_count = filtered_datasts.length;
         self.SET_FILTERED_ITEM_COUNT(filtered_datasets.length);
         
         if(self.sort_by['sort_dir'] != '') {
            let sorted_filtered_datasets = Vue._.orderBy(filtered_datasets, [function(dataset) {               
               if(self.sort_by['field'] == 'ProcessingLevel') {
                  return dataset['umm']['ProcessingLevel']['Id'];
               } else if(self.sort_by['field'] == 'start') {
                  if(dataset['umm']['TemporalExtents'][0]['RangeDateTimes'] && dataset['umm']['TemporalExtents'][0]['RangeDateTimes'][0]['BeginningDateTime']) {
                     return dataset['umm']['TemporalExtents'][0]['RangeDateTimes'][0]['BeginningDateTime'];
                  } else {
                     return '';
                  }
               } else if(self.sort_by['field'] == 'end') {
                  if(dataset['umm']['TemporalExtents'][0]['RangeDateTimes'] && dataset['umm']['TemporalExtents'][0]['RangeDateTimes'][0]['EndingDateTime']) {
                     return dataset['umm']['TemporalExtents'][0]['RangeDateTimes'][0]['EndingDateTime'];
                  } else {
                     return '';
                  }
               }
            }],[self.sort_by['sort_dir']]);
            filtered_datasets = sorted_filtered_datasets;
         }         

         return filtered_datasets.slice(0, self.load_item_count);
      },
      science_keyword_filtered_datasets: function() {
         let self = this;
         let filtered_dataset_array = self.cloud_datasets.filter(function(dataset) {
            let science_keywords = self.dataset_unique_science_keywords(dataset['umm']['ScienceKeywords']), to_return = true;

            if(!science_keywords.includes(self.modal_science_keyword['keyword'])) {
               to_return = false;
            }

            return to_return;
         });

         return filtered_dataset_array;
      }
   },
}